import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog } from "@mui/material";

import { toUSDFormat } from "../../utils/utils";
import useStyles from "./BulletFactorySuccessPopupStyles";

import logoImg from "../../assets/imgs/crime/checkmark.png";
import cashImg from "../../assets/imgs/exchange/money.png";
import bulletImg from "../../assets/imgs/inventory/bulletitem.png";

interface BulletFactorySuccessPopupProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  cashAmount: number;
  bulletAmount: number;
}

const BulletFactorySuccessPopup: React.FC<BulletFactorySuccessPopupProps> = ({
  openModal,
  setOpenModal,
  cashAmount,
  bulletAmount,
}) => {
  const { classes } = useStyles();

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box component={"img"} src={logoImg} className={classes.logoImg} />
          <Box className={classes.titleText}>You bought bullets!</Box>

          <Box className={classes.details}>
            <Box className={classes.detailColumn}>
              <Box>Amount:</Box>
              <Box>
                <Box component={"img"} src={bulletImg} />{" "}
                {toUSDFormat(bulletAmount)}
              </Box>
            </Box>
            <Box className={classes.detailColumn}>
              <Box>Cost:</Box>
              <Box>
                <Box component={"img"} src={cashImg} />{" "}
                {toUSDFormat(cashAmount)}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default BulletFactorySuccessPopup;
